export const isAuthenticated = (authStatus?: string) => authStatus === 'authenticated'
